<template>
  <div class="main-content">
    <div class="card">
      <div class="card-header position-relative">
        <h5>Запросы</h5>
        <button @click="getRecords" class="position-absolute btn btn-outline-success">Обновить запросы</button>
      </div>
      <div class="card-body">
        <pulse-loader :loading="loading" :color="loadingColor" class="text-center"/>
        <div>
          <Chat ref="chat"/>
        </div>
      </div>
    </div>

    <div class="card" v-if="$currentRole === 'admin' || $currentUID === 91">
      <div class="card-body">
        <TelegramMessageSender/>
      </div>
    </div>

  </div>
</template>

<script>

import api from '@/api'
import moment from 'moment'
import LoadingButton from '@/components/buttons/LoadingButton'
import store from "@/store";
import Chat from '@/components/chat/Chat'
import TelegramMessageSender from '@/components/telegram/TelegramMessageSender'

export default {
  components: {
    LoadingButton,
    Chat,
    TelegramMessageSender,
  },
  data() {
    return {
      loading: false,
      records: [],
      users: {},
      dialogs: [],
      btnLoading: {},
      comments: {},
      saveCommentLoading: {},
      loadingColor: this.$constants.LOADING_COLOR,
    }
  },
  mounted() {
    // this.getRecords()
  },
  methods: {
    async acceptDialog(id) {
      this.btnLoading[id] = true
      const {data} = await api.post('/notifications/updateDialog', {
        type: 'accept',
        dialog_id: id
      })
      if (data.success) {
        const index = this.dialogs.findIndex((d) => d.id === id)
        toastr['success']('Сохранено', 'Успешно')
        this.dialogs[index].is_accepted = 1
      } else {
        toastr['warning'](data.message || 'Ошибка сервера')
      }
      this.btnLoading[id] = false
    },
    async saveNewMessage(id) {
      if (this.saveCommentLoading[id] || !this.comments[id]) return
      this.saveCommentLoading[id] = true
      const {data} = await api.post('/notifications/sendMessage', {
        type: 'message',
        dialog_id: id,
        message: this.comments[id]
      })
      if (data.success) {
        const index = this.dialogs.findIndex((r) => r.id === id)
        this.comments[id] = null
        if (!this.dialogs[index].messages) this.dialogs[index].messages = []
        this.dialogs[index].messages.push(data.record)
        toastr['success']('Сохранено', 'Успешно')
        this.comments[id] = null
      } else {
        toastr['warning'](data.message || 'Ошибка сервера')
      }
      this.saveCommentLoading[id] = false
    },
    async saveComment(id) {
      if (this.saveCommentLoading[id] || !this.comments[id]) return
      this.saveCommentLoading[id] = true
      const {data} = await api.post('/notifications/updateMessage', {
        type: 'message',
        record_id: id,
        message: this.comments[id]
      })
      if (data.success) {
        const index = this.records.findIndex((r) => r.id === id)
        this.comments[id] = null
        if (!this.records[index].answers) this.records[index].answers = []
        this.records[index].answers.push(data.record)
        toastr['success']('Сохранено', 'Успешно')
      } else {
        toastr['warning'](data.message || 'Ошибка сервера')
      }
      this.saveCommentLoading[id] = false
    },
    async acceptRequest(id) {
      if (this.btnLoading[id]) return
      this.btnLoading[id] = true
      const {data} = await api.post('/notifications/updateMessage', {
        type: 'accept',
        record_id: id,
      })
      if (data.success) {
        const index = this.records.findIndex((r) => r.id === id)
        this.records[index].is_accepted = 1
        toastr['success']('Сохранено', 'Успешно')
      } else {
        toastr['warning'](data.message || 'Ошибка сервера')
      }
      this.btnLoading[id] = false
    },
    async solveDialog(id, deleteMessages = false) {
      this.btnLoading[id] = true
      const {data} = await api.post('/notifications/closeDialog', {
        type: 'solve',
        clearHistory: deleteMessages,
        dialog_id: id
      })
      if (data.success) {
        this.dialogs = this.dialogs.filter((r) => r.id !== id)
        // const badgeDialogs = this.$ActiveNotifications.filter((n) => n.id !== id)
        // this.$store.dispatch('platform/setActiveNotifications', [...badgeDialogs])
        toastr['success']('Сохранено', 'Успешно')
      } else {
        toastr['warning'](data.message || 'Ошибка сервера')
      }
      this.btnLoading[id] = false
    },
    async solveRequest(id) {
      this.btnLoading[id] = true
      const {data} = await api.post('/notifications/updateMessage', {
        type: 'solve',
        record_id: id
      })
      if (data.success) {
        this.records = this.records.filter((r) => r.id !== id)
      } else {
        toastr['warning'](data.message || 'Ошибка сервера')
      }
      this.btnLoading[id] = false
    },
    async makeRead() {

    },
    orderToEdit(id, dialog) {
      this.$store.dispatch('orders/setOrderToEdit', {orderId: id, dialog: dialog})
    },
    async getRecords() {
      this.$refs.chat.getActiveChats();
      return;
      this.loading = true
      const {data} = await api.index('/notifications/list')
      if (data.success) {
        this.users = data.users.reduce((acc, u) => {
          acc[u.id] = u
          return acc
        }, {})
        this.dialogs = data.dialogs
        // await this.$store.dispatch('platform/setActiveNotifications', [...this.dialogs])

        const records = []
        const comments = {}
        this.btnLoading = data.records.reduce((acc, r) => {
          acc[r.id] = false
          let text = r.text || r.data.message
          r.text = text ? text.replace(/(?:\r\n|\r|\n)/g, '<br />') : null
          records.push(r)
          comments[r.id] = null
          return acc
        }, {})
        this.comments = {...comments}
        this.saveCommentLoading = {...comments}
        this.records = records
      } else {
        toastr['warning'](data.message || 'Ошибка сервера')
      }
      this.loading = false
    },
    moment: function (date, format = 'DD.MM.YYYY') {
      if (!date) return
      return moment(date).format(format)
    },
  }
}
</script>

<style scoped>
.answers p {
  margin-bottom: 2px;
}

.answers .text-muted {
  font-size: 12px;
}

.message_text {
  /*white-space: pre;*/
}

.position-relative {
  position: relative;
}

.position-absolute {
  position: absolute;
  right: 5px;
  top: 5px;
}

.icon-fa.green {
  color: #58e858;
}

.icon-fa.blue {
  color: #5BBFDE;
}
</style>
